import script from "./HomeBlocks.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeBlocks.vue?vue&type=script&setup=true&lang=js"

import "./HomeBlocks.vue?vue&type=style&index=0&id=2cf66bfb&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cf66bfb"]])

export default __exports__